import styled from 'styled-components';
import navArrow from '../../../images/channel-switch/nav-arrow.svg';

const SwitchButtonStyled = styled.button`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  border: none;
  cursor: pointer;
  background: unset;
  padding: unset;
  margin: unset;
`;

const ButtonTitleStyled = styled.span`
  display: none;
  @media (min-width: 769px) {
    display: inline;
    color: white;
    font-family: cerapro;
    font-size: 14px;
    line-height: 18px;
    margin-left: 7px;
  }
`;

const PanelContentStyled = styled.section`
  display: flex;
  flex-direction: column;
  padding: 32px 40px;
`;

const ContentHeaderStyled = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  line-height: 18px;
  color: #494c66;
  text-align: center;

  strong {
    font-size: 18px;
    line-height: 20px;
    font-weight: bold;
    color: #0e141d;
    padding-top: 4px;
  }
`;

const ChannelNavStyled = styled.nav`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding-top: 32px;
`;

const NavTitleStyled = styled.span`
  font-size: 18px;
  line-height: 20px;
  color: #494c66;
  text-align: center;
`;

const ChannelButtonStyled = styled.button`
  display: flex;
  align-items: center;
  font-family: cerapro;
  font-size: 16px;
  line-height: 20px;
  color: #0e141d;
  border: 1px solid #c9cfd7;
  border-radius: 8px;
  cursor: pointer;
  background: unset;
  margin: 15px 0 0;
  padding: 12px 16px;
  transition: all 0.4s;
  :hover {
    border-color: #4d008c;
  }

  :after {
    content: '';
    width: 16px;
    height: 24px;
    margin-left: auto;
    background: url(${navArrow}) center right no-repeat;
  }
`;

const ButtonIconStyled = styled.span`
  width: 34px;
  border-right: 1px solid #c9cfd7;
  margin-right: 12px;
  transition: border-color 0.4s;
  ${ChannelButtonStyled}:hover & {
    border-color: #4d008c;
  }
`;

export {
  SwitchButtonStyled,
  ButtonTitleStyled,
  PanelContentStyled,
  ContentHeaderStyled,
  ChannelNavStyled,
  NavTitleStyled,
  ChannelButtonStyled,
  ButtonIconStyled,
};
